// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3haPK","tab":"Tabs_tab__1Wkbt","tabActive":"Tabs_tabActive__tTBs0"};